import React, { useEffect, useState, useContext} from 'react'
import {Card, CardHeader, CardActions, CardContent,Typography, Button, Alert, Box} from '@mui/material'
import Axios from 'axios'
import {useParams} from 'react-router-dom'
import {Loader} from './Loader'
import {Dialogos} from './Dialogos'
import { Precios } from './Precios';
import {useHelper} from '../hooks/useHelper';
import { PreguntasFrecuentes } from './PreguntasFrecuentes';
import { NuevoEventosPorUsuario } from './NuevoEventosPorUsuario';
import { formularioContext } from '../contextos/FormularioContext';
import moment from 'moment'
import { Default } from './Default';

export const Eventos = ()=>{
    const [eventos,setEventos] = useState([])
    const [esModoTest,setEsModoTest] = useState(false)
    const [noAutorizado,setNoAutorizado] = useState(false)
    const [cargando,setCargando]= useState(true)
    const parametros = useParams()
    const [idEvento,setUpdateEvento] = useState(null)
    const [eventoSeleccionado,setEventoSeleccionado]=useState(null)
    const [abrirPreguntas,setAbrirPreguntas]=useState(null)
    const {hacerScroll} = useHelper()
    const { datos,
        datosMinistroOk,
        infoMinistro,
        setIdEvento,
        esCelular,
        handleChangeDocumento,
        } = useContext(formularioContext)

    useEffect(()=>{
        const obtenerEventoParaTesting = async ()=>{
            try{
                const {data} = await Axios.get(process.env.NODE_ENV =='development' ? `http://localhost:3020/documentos/validartokentest/${parametros?.token}`:`https://uadapi.uad.digital/documentos/validartokentest/${parametros?.token}`)
                if(data[0]?.id_evento){
                    setEventos(data) 
                    setEsModoTest(true)
                }
                setCargando(false)
            }catch(err){
                setEventos([])
                setEsModoTest(false)
                setCargando(false)
                console.log('Error al acceder con un token de test',err, JSON.stringify(err?.response) )
                if(err?.response?.data?.message=="jwt expired")
                    {
                        alert('El token del evento ha expirado. Luego de ser generado desde administración tiene una duración de 1 hora')
                    }else{
                        alert('El token del evento no es válido o ha expirado')
                    }
            }
           
        }

        const validarTokenParaTesting = async ()=>{
            try{
                const {data} = await Axios.get(process.env.NODE_ENV =='development' ? `http://localhost:3020/documentos/validartokentest/${parametros?.token}`:`https://uadapi.uad.digital/documentos/validartokentest/${parametros?.token}`)
                if(data?.autorizado){
                    setEsModoTest(true)
                    setNoAutorizado(false)
                }else{
                    setEsModoTest(true)
                    setNoAutorizado(true)
                }
                setCargando(false)
            }catch(err){
                setEsModoTest(true)
                setNoAutorizado(true)
                setCargando(false)
                console.log('Error al acceder con un token de test',err, JSON.stringify(err?.response) )
                if(err?.response?.data?.message=="jwt expired")
                    {
                        alert('El token ha expirado')
                    }else{
                        alert('El token no es válido o ha expirado')
                    }
            }
           
        }

        const validarTokenMinistro = async ()=>{
            try{
                const {data} = await Axios.get(process.env.NODE_ENV =='development' ? `http://localhost:3020/documentos/validartokenevent/${parametros?.tokenmin}`:`https://uadapi.uad.digital/documentos/validartokenevent/${parametros?.tokenmin}`)
                if(data?.autorizado){
                    alert('autorizado! ' + ' ' + data?.dni)
                    handleChangeDocumento({target:{value:Number(data?.dni).toString()}})
                }else{
                    alert('no autorizado')
                }
                setCargando(false)
            }catch(err){
                setEsModoTest(true)
                setNoAutorizado(true)
                setCargando(false)
                console.log('Error al acceder con un token de ministro',err, JSON.stringify(err?.response) )
                if(err?.response?.data?.message=="jwt expired")
                    {
                        alert('El token ha expirado')
                    }else{
                        alert('El token no es válido o ha expirado')
                    }
            }
           
        }


        if(parametros?.token){
//            obtenerEventoParaTesting()
            validarTokenParaTesting()
        }else if (parametros?.tokenmin) {
            validarTokenMinistro()
        }else{
            setCargando(false)
            setEsModoTest(false)
            setNoAutorizado(false)
        }

    },[parametros])

    useEffect(()=>{

        const obtenerEventos = async ()=>{
            try{
                const uad = datos.ministroUad=='ministrouad' ? 1 : 0;
                const rutaCondicional = esModoTest ? 'eventstest' : 'events'
                const {data} = await Axios.get(process.env.NODE_ENV =='development' ? `http://localhost:3020/documentos/${rutaCondicional}/${uad}`:`https://uadapi.uad.digital/documentos/${rutaCondicional}/${uad}`)
                setEventos(data)
                const evento_principal = data.filter(i=>i.es_principal) || [];
                setUpdateEvento(evento_principal[0]?.id_evento)
                setCargando(false)
              
            }catch(err){
                console.log('Error loading events',err)
                setCargando(false)
            }
           
        }

        setEventoSeleccionado(null)

        if(!(datos.ministroUad==undefined)){
            obtenerEventos()
         }else{
            setEventos([])
            setUpdateEvento(null)
        }
        
    },[datos.ministroUad])

    useEffect(()=>{
        if(idEvento){
            const evento = eventos.filter(i=>i.id_evento===idEvento)[0];
            setEventoSeleccionado(evento);
            setIdEvento(idEvento)
            setTimeout(() => {
                hacerScroll("evento-inicio")
            }, 200);
        }else{
            setEventoSeleccionado(null);
            setIdEvento(process.env.REACT_APP_ID_EVENTO)
        }
    },[idEvento])

    if (cargando){
        return  <Loader open={true} 
        texto='Cargando...'/>
    }

    if(noAutorizado){
        return <Default texto='El token provisto no lo autoriza a visualizar los eventos inactivos en modo test'/>
    }

//     return         <Box
//             sx={{
// //                backgroundImage: "url('/images/home-custom.png')",
//                 backgroundSize: 'cover',
//                 backgroundPosition: 'center',
//                 minHeight: '100vh',
//                 display: 'flex',
//                 alignItems: 'center',
//                 background:'blue',
//                 justifyContent: 'center',
//                 //flexDirection: { xs: 'column', lg: 'row' }
//                 flexDirection: 'column'
//             }}
//         >
//         <h1>inicio</h1>
//             <NuevoEventosPorUsuario esModoTest = {esModoTest} dniministrotoken={parametros?.tokenmin ? true : false}/>
//                    <h1>inicio</h1>

//             {/* {(datosMinistroOk()[0] || datos.ministroUad=='externo') && <>
//                 {eventoSeleccionado && <Box className="flex flex-col">
//                     <EventoSeleccionado
//                     volverInicio = {()=>setUpdateEvento(null)}
//                     eventos = {eventos}
//                     setUpdateEvento = {setUpdateEvento}
//                     eventoSeleccionado = {eventoSeleccionado}
//                     setAbrirPreguntas = {setAbrirPreguntas}
//                     idEvento = {idEvento}
//                     esCelular={esCelular}
//                 >
//                 </EventoSeleccionado>
//                 </Box>}
//                 {eventoSeleccionado?.id_preguntas_frecuentes && <PreguntasFrecuentes id={eventoSeleccionado?.id_preguntas_frecuentes}
//                 />}
//                 {!eventoSeleccionado && datosMinistroOk()[0] && <Visualizar_Seleccionar_Eventos 
//                     eventos = {eventos}
//                     setUpdateEvento = {setUpdateEvento}
//                     esModoTest = {esModoTest}
//                 />} 
//             </>} */}
           
//         </Box>
//     return <div className='bg-blue-gray-900'>
//         <h1>inicio</h1>
//     </div>
    return (
        <Box
            sx={{
//                backgroundImage: "url('/images/home-custom.png')",
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                //flexDirection: { xs: 'column', lg: 'row' }
                flexDirection: 'column'
            }}
        >
            
            {/*<div style={{backgroundColor: '#f8f8ff',borderBottom:'solid 1px gray'}}>
                <Logo width="50" nocentrar/> 
                {esModoTest && <Alert className='blink' severity='warning'>
                    Esta visualizando eventos inactivos en modo test
                </Alert>}
            </div>*/}
            <NuevoEventosPorUsuario esModoTest = {esModoTest} dniministrotoken={parametros?.tokenmin ? true : false}/>
            {(datosMinistroOk()[0] || datos.ministroUad=='externo') && <>
                {eventoSeleccionado && <Box className="flex flex-col">
                    <EventoSeleccionado
                    volverInicio = {()=>setUpdateEvento(null)}
                    eventos = {eventos}
                    setUpdateEvento = {setUpdateEvento}
                    eventoSeleccionado = {eventoSeleccionado}
                    setAbrirPreguntas = {setAbrirPreguntas}
                    idEvento = {idEvento}
                    esCelular={esCelular}
                >
                </EventoSeleccionado>
                {/* {eventoSeleccionado?.id_preguntas_frecuentes && <PreguntasFrecuentes id={eventoSeleccionado?.id_preguntas_frecuentes}
                />} */}
                </Box>}
                {eventoSeleccionado?.id_preguntas_frecuentes && <PreguntasFrecuentes id={eventoSeleccionado?.id_preguntas_frecuentes}
                />}
                {!eventoSeleccionado && datosMinistroOk()[0] && <Visualizar_Seleccionar_Eventos 
                    eventos = {eventos}
                    setUpdateEvento = {setUpdateEvento}
                    esModoTest = {esModoTest}
                />} 
            </>}
        </Box>
    )
    
}

const ListaEventos = ({eventos,setUpdateEvento})=>{
    if(!eventos.length){
        return null
    }

    return (
        <Card className="flex m-[1rem]">
            <Button
                variant="text"
                onClick={() => setUpdateEvento(null)}
                className="flex items-center space-x-2 text-blue-600"
            >
                <span className="material-icons">arrow_back</span>
                <Typography variant="subtitle">Volver a todos los eventos</Typography>
            </Button>
        </Card>
    );
}

const EventoSeleccionado = ({idEvento,eventos,setUpdateEvento,eventoSeleccionado,setAbrirPreguntas,volverInicio,esCelular,children})=>{
//    return <Card className='flex flex-col justify-center pb-3 lg:max-w-[570px]'>
    return <Card className='flex flex-col justify-center pb-3'>
            {/* <ListaEventos eventos={eventos.filter(i=>i.id_evento!=eventoSeleccionado?.id_evento)} setUpdateEvento={setUpdateEvento}/> */}
            <div className="flex flex-wrap justify-center bg-cover bg-center">
                <div className="w-full">
                    <div className='pt-3 border-b-[1px]'> 
                        {/* <img
                            src={eventoSeleccionado?.flyer_web}
                            alt={eventoSeleccionado?.titulo}
                            className={`mx-auto rounded-md ${esCelular ? 'w-[90%]' : 'w-[94%]'}`}
                        /> */}

                        {/* <div className='px-10'>
                            <CardHeader
                                id="evento-inicio"
                                title={eventoSeleccionado?.titulo}
                                subheader={eventoSeleccionado.subtitulo}
                                titleTypographyProps={{ align: 'center', fontSize: 35 }}
                                subheaderTypographyProps={{ align: 'center', variant: 'h6', color: 'textSecondary' }}
                            />
                        </div>

                             <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    padding: '0 75px',
                                    marginBottom: -20,
                                }}
                            >
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <span className="material-icons" style={{ marginRight: '8px', color: '#1976d2', fontSize: '36px' }}>
                                        event
                                    </span>
                                    <Typography variant="h6" style={{ lineHeight: 1.2, maxWidth: 190, fontWeight: 300 }}>{eventoSeleccionado.descripcion}</Typography>
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', maxWidth: '250px' }}>
                                    <span className="material-icons" style={{ marginRight: '8px', color: '#1976d2', fontSize: '36px' }}>
                                        location_on
                                    </span>
                                    <Typography variant="h6" style={{ lineHeight: 1.2, fontWeight: 300 }}>{eventoSeleccionado.detalles}</Typography>
                                </div>
                            </div>  */}

                        {/* <CardContent>
                        
                            {eventoSeleccionado.texto1 && <Typography variant="body1" sx3={{ padding: '16px', fontSize: '1.5rem' }} align="left">
                            {eventoSeleccionado.texto1}
                            </Typography>}
                            {eventoSeleccionado.texto2 && <Typography variant="body1" sx3={{ padding: '16px', fontSize: '1.5rem' }} align="left">
                            {eventoSeleccionado.texto2}
                            </Typography>}
                            {eventoSeleccionado.texto3 && <Typography variant="body1" sx3={{ padding: '16px', fontSize: '1.5rem' }} align="left">
                            {eventoSeleccionado.texto3}
                            </Typography>}
                            {eventoSeleccionado.texto4 && <Typography variant="body1" sx3={{ padding: '16px', fontSize: '1.5rem' }} align="left">
                            {eventoSeleccionado.texto4}
                            </Typography>}
                        </CardContent> */}
                        </div>
                        <Precios evento={eventoSeleccionado} id_evento={idEvento} volverInicio={volverInicio}/>
                </div>
            </div>
            {children}
</Card>
}


const Visualizar_Seleccionar_Eventos = ({ eventos, setUpdateEvento, esModoTest }) => {
    return (
        <Box
            sx={{
                mt: { xs: '-20px', lg: 0 },
                overflow: 'auto',
                height: { xs: '100%', lg: '100vh' },
                maxWidth: { xs: '100%', lg: '550px' }
            }}
        >
        <Card className="flex flex-col p-[20px]">
          <Typography variant="h3" align="center" style={{ margin: '1.5rem' }}>
            Próximos eventos:
          </Typography>
  
          <div
            style={{
              minHeight: '350px',
              marginTop: '30px',
              display: 'flex',
              flexWrap: 'wrap',
              gap: '30px',
              justifyContent: 'center',
              padding: '10px',
            }}
          >
            {eventos.length === 0 && (
              <Alert severity="info">No hay eventos en este momento</Alert>
            )}
  
            {eventos
              .filter((i) => i?.activo || esModoTest)
              .map((evento, index) => (
                <Card
                  key={evento.id_evento}
                  variant="outlined"
                  style={{
                    width: '100%',
                    background:
                      process.env.REACT_APP_PRECIOS_CARDS || '#c3c3cf',
                  }}
                >
                  <img
                    src={evento?.foto_mini}
                    style={{ width: '100%', height: 'auto', objectFit: 'cover' }}
                    alt="evento"
                  />
  
                  <CardHeader
                    title={evento.titulo}
                    titleTypographyProps={{
                      variant: 'h6',
                      align: 'center',
                      color: 'primary',
                    }}
                  />
                  <Typography variant="subtitle2">{evento.detalles}</Typography>
                  <CardContent>
                    <Typography style={{ margin: '10px' }} color="text.secondary">
                      {evento.descripcion}
                    </Typography>
                  </CardContent>
                  <CardActions style={{ justifyContent: 'center' }}>
                    <Button
                      onClick={() => setUpdateEvento(evento.id_evento)}
                      size="small"
                      variant="outlined"
                      color="primary"
                    >
                      Más info aquí
                    </Button>
                  </CardActions>
                </Card>
              ))}
          </div>
        </Card>
      </Box>
    );
  };